<div
  data-cy="people-hierarch-container"
  class="hierarchy-item-container"
  [ngClass]="{ 'hierarchy-item-popup-state': isPopUp, 'large-width': !smallWidth }"
>
  <div (click)="onSelectedItem()" class="hierarchy-item-wrapper" [ngClass]="{ 'hierarchy-item-wrapper-current': isCurrent }">
    <avatar
      data-cy="people-hierarch-avatar"
      [fallback]="item?.fallbackIcon"
      [ngClass]="{ 'hierarchy-item-avatar': true, 'hierarchy-item-avatar-current': isCurrent }"
      [url]="item?.icon"
      [size]="'none'"
    ></avatar>
    <div class="hierarchy-item-titles-container">
      <span
        data-cy="people-hierarch-title"
        [ngClass]="{
          title: true,
          'title-current': isCurrent
        }"
        >{{ item?.title }}</span
      >
      <span data-cy="people-hierarch-subtitle" class="sub-title">{{ item?.subTitle }}</span>
    </div>
    <div
      data-cy="people-hierarch-count"
      class="hierarchy-item-count"
      *ngIf="item.countAll"
      pTooltip="{{ item?.countDirect }} direct, {{ item?.countAll }} in total"
      tooltipPosition="bottom"
      tooltipStyleClass="u-tooltip"
    >
      <span class="count-txt">{{ item?.countAll >= 10000 ? '+10000' : item?.countAll }}({{ item?.countDirect }})</span>
    </div>
  </div>
  <div>
    <div *ngIf="hasChild" class="hierarchy-item-seperate-line"></div>
  </div>
</div>
